var map = {
	"./admin_settings.png": 1692,
	"./catalog.png": 1693,
	"./catalogWhite.png": 1694,
	"./catalog_orders.png": 1695,
	"./cms.png": 1696,
	"./component-fields/Asset.png": 1697,
	"./component-fields/Blocks.png": 1698,
	"./component-fields/Boolean.png": 1699,
	"./component-fields/Date-time.png": 1700,
	"./component-fields/LInk.png": 1701,
	"./component-fields/Markdown.png": 1702,
	"./component-fields/Multi asset.png": 1703,
	"./component-fields/Multi options.png": 1704,
	"./component-fields/Number.png": 1705,
	"./component-fields/Richtext.png": 1706,
	"./component-fields/Single options.png": 1707,
	"./component-fields/Table.png": 1708,
	"./component-fields/Text area.png": 1709,
	"./component-fields/Text.png": 1710,
	"./components.png": 1711,
	"./configuration.png": 1712,
	"./contents.png": 1713,
	"./crm.png": 1714,
	"./custom_order.png": 1715,
	"./customer_credits.png": 1716,
	"./customer_list.png": 1717,
	"./dashboard.png": 1718,
	"./finance.png": 1719,
	"./home.png": 1720,
	"./integrations.png": 1721,
	"./inventory-transfers.png": 1722,
	"./invoice-list.png": 1723,
	"./layaway.png": 1724,
	"./move.png": 1725,
	"./new_sale.png": 1726,
	"./orders.png": 1727,
	"./outgoing-consignments.png": 1728,
	"./payment-methods/amex.png": 1120,
	"./payment-methods/discover.png": 1119,
	"./payment-methods/mastercard.png": 1118,
	"./payment-methods/visa.png": 1117,
	"./payments.png": 1729,
	"./register.png": 1730,
	"./repair_center.png": 1731,
	"./reports.png": 1732,
	"./services.png": 1733,
	"./trade_in_center.png": 1734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1343;